import { gridThemeNamespace, IGridTheme } from '@xcritical/grid';

import { colors, sizes } from '@crm-framework/theme';

const gridTheme: IGridTheme = {
  evenRowBackground: colors.WHITE,
  border: 'none',
  rowCellBorder: 'none',
  borderRadius: 3,
  header: {
    border: 'none',
    backgroundColor: colors.WHITE,
  },
  headerCellContent: {
    fontSize: sizes.DEFAULT_FONT_SIZE,
    padding: '0 10px',
  },
  row: {
    border: `1px solid ${colors.DEFAULT_BORDER}`,
    fontSize: sizes.DEFAULT_FONT_SIZE,
  },
};

export const notificationGridTheme = {
  [gridThemeNamespace]: gridTheme,
};
